import React, { useEffect } from "react";
import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Colors } from "../../../assets/Colors";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import LOGO_RKS from "../../../assets/logo/LOGO_RKS.png";

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 67,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
  },
  viewHeader: {
    width: 400,
    marginLeft: 0,
    marginTop: -37,
  },
  title_sub: {
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
  },
  header_kepada: {
    fontWeight: "bold",
    fontSize: 12,
  },
  bottom_ttd: {
    paddingTop: 50,
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "center",
    border: 1,
    width: 132,
  },
  bottom_ttdL: {
    paddingTop: 50,
    paddingLeft: 5,
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "left",
    border: 1,
    width: 132,
  },
  bottom_ttdB: {
    paddingLeft: 5,
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "left",
    border: 1,
    borderTop: 0,
    width: 132,
  },

  header_namasupp: {
    fontWeight: "bold",
    fontSize: 12,
    textTransform: "capitalize",
  },
  title_border: {
    marginBottom: 2,
    fontSize: 11,
    fontWeight: "bold",
    textAlign: "left",
  },
  Stitle_border: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 20,
    marginRight: 15,
  },

  header_section: {
    flexDirection: "row",
  },

  header_title: {
    width: 270,
    fontSize: 9,
    textAlign: "justify",
  },
  header_Right: {
    width: 70,
    marginLeft: 105,
    fontSize: 9,
    textAlign: "left",
  },
  header_Rightv: {
    width: 70,
    marginLeft: 133,
    fontSize: 9,
    textAlign: "left",
  },
  header_mark: {
    width: 15,
    fontSize: 9,
    textAlign: "justify",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 9,
    textAlign: "justify",
  },

  table: {
    display: "flex",
    flexDirection: "row",
    borderLeftWidth: 1,
    // borderRadius: 5,
    borderStyle: "solid",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 8,
  },
  cellSecondary: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderTop: 0,
    borderLeftWidth: 0,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellClosing: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  paddings: {
    paddingTop: 10,
  },
  logo: {
    width: 200,
    marginBottom: 20,
    marginLeft: 570,
  },
  Middleman: {
    width: 200,
    fontSize: 9,
  },
  header_RightA: {
    width: 135,
    marginRight: 5,
    fontSize: 9,
    textAlign: "left",
  },
  bottom_ttdNP: {
    marginTop: 10,
    fontWeight: "bold",
    fontSize: 9,
    border: 1,
    // paddingLeft: 38,
    textAlign: "center",
    width: 132,
    borderBottom: 0,
  },
});

const combineStyles = (main, override) => {
  let result = { ...main };
  let ov = { ...override };
  if (typeof override === "object") {
    Object.assign(result, ov);
  }
  return result;
};
// Create Document Component
const PdfPayrollReportFormat = (props) => {
  const data = props.data
  
  var grandTotal = 0;
  var totalTunjangan = 0;
  var totalExtraMakan = 0;
  var totalLembur = 0;
  var grandtotalAll = 0;
  var totalBPJSTK = 0;
  var totalBPJSKS = 0;
  var totalGajiBersih = 0;

  const [IsFixed, setIsFixed] =
  React.useState(true);
// Object.keys(data.data).forEach((element) => {
//         data.data[element].map((e, i) => {
//             console.log(e["NamaKaryawan"])
//         })
//         // console.log(i)
//     });
// if (Object.isArray(data.data)) {
//       data.data.map((values, id) => {
//         let closing = false;
//         if (id === data.length - 1) {
//           closing = true;
//         }
//         console.log(id)
//       })

//   }

  const HeaderTableMaker = (props) => {
    let style = { width: props.width + "%" };
    let style2 = {};
    let style3 = {};
    let style4 = {};
    let style5 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    if (props.number) {
        style5 = { textAlign: "right" };
    }
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    if (props.bold) {
      style4 = {
        textWeight: "Bold",
        fontSize: 9,
      };
    }
    return (
      <Text
        style={combineStyles(combineStyles(combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        ), style4), style5)}
      >
        {props.title}
      </Text>
    );
  };
  const SecondaryTableMaker = (props) => {
    
    let style = { width: props.width + "%" };
    let style2 = {};
    if (props.closing) {
      style2 = { borderBottom: 1 };
    }
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 22 };
    }

    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cellSecondary, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };

//   let Total = 0;
//   let TotalK = 0;
//   data.Data &&
//     data.Data.map((values, id) => {
//       Total = Total + parseFloat(values.Debet);
//       TotalK = TotalK + parseFloat(values.Kredit);
//     });
//   const GTotalK = TotalK;
//   const GTotalD = Total;
  const HeaderTableMakerMid = (props) => {
    let style = {
      width: props.width + "%",
      textAlign: "center",
      paddingRight: props.padding,
    };
    let style2 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    let style3 = {};
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };

  const Grandtotal = () => {
    return (
        <View style={styles.table}>
            <View style={[styles.tableRow]}>
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                width={26}
                title={"Grand Total"}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                width={15}
                title={""}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={7}
                title={(grandTotal).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={7}
                title={(totalTunjangan).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={7}
                title={(totalExtraMakan).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={8}
                title={(Math.round(totalLembur)).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={8}
                title={(Math.round(grandtotalAll)).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={7}
                title={(totalBPJSTK).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={7}
                title={(totalBPJSKS).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                <HeaderTableMaker
                colored={true}
                bold={true}
                closing={true}
                number={true}
                width={8}
                title={(totalGajiBersih).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                />
                
            </View>
        </View>
    )
  }

  const RowsBagian = (props) => {
    const data = props.dataobj
    let closing = props.closing
    return (
        <>
        <View style={styles.table} key={props.data}>
            <View style={[styles.tableRow]}>
                <HeaderTableMaker
                width={26}
                title={props.data}
                />
                <HeaderTableMakerMid
                width={15}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={59}
                title={""}
                />
                
            </View>
        </View>
        
        {data.Data[props.data].map((datas, i) => {
          let totalAll
          let totalAllBulat
          totalAll = Math.floor(parseFloat(datas["UpahPokok"])+datas["TotalLembur"]+datas["TotalTunjangan"]+datas["TotalMakanLembur"])
          if (datas["GajiBersih"] == "") {
            totalAllBulat = Math.floor(totalAll- parseFloat(datas["BPJSTK"]) - parseFloat(datas["BPJSKS"]))
          }else{
            totalAll = parseFloat(datas["JumlahUpahdanLembur"])
            // totalAllBulat = Math.floor(parseFloat(datas["GajiBersih"]) - parseFloat(datas["BPJSTK"]) - parseFloat(datas["BPJSKS"]))
            totalAllBulat = Math.floor(parseFloat(datas["GajiBersih"]))
            
          }

            // parseFloat(Math.round(
            //                     (Math.floor(
            //                       keyName["UpahPokok"] +
            //                         keyName["JamLembur"] *
            //                           (keyName["UpahPokok"] / 173)
            //                     ) -
            //                       Math.floor(
            //                         keyName["UpahPokok"] *
            //                         3 /
            //                         100
            //                       ) -
            //                       Math.floor(
            //                         keyName["UpahPokok"] *
            //                         1 /
            //                         100
            //                       ) + 
            //                       (keyName["HariLemburMakan"] *
            //                       20000) 
            //                       + 
            //                       (keyName["HariKerja"] * 20000)) /
            //                       1000
            //                   ) * 1000)
            let closingrow = false
            let closingrow1 = false
            grandTotal += datas["UpahPokok"]
            totalTunjangan += datas["TotalTunjangan"];
            totalExtraMakan += datas["TotalMakanLembur"];
            totalLembur += datas["TotalLembur"];
            grandtotalAll += totalAll;
            totalBPJSTK += parseFloat(datas["BPJSTK"]);
            totalBPJSKS += parseFloat(datas["BPJSKS"]);
            totalGajiBersih += Math.round(totalAllBulat/1000) *1000;
            if (i == data.Data[props.data].length - 1) {
                closingrow1 = true;
            }
            if (closing) {
                if (i == data.Data[props.data].length - 1) {
                    closingrow = false;
                }else{
                    closingrow = false
                }
            }
            return (
                <View style={styles.table} key={datas["NamaKaryawan"]}>
                    <View style={[styles.tableRow]}>
                        <HeaderTableMakerMid
                        closing={closingrow}
                        width={3}
                        title={i+1}
                        />
                         <HeaderTableMaker
                        closing={closingrow}
                        width={8}
                        title={datas["Nik"]}
                        />
                        <HeaderTableMaker
                        closing={closingrow}
                        width={15}
                        title={datas["NamaKaryawan"]}
                        />
                        <HeaderTableMaker
                        closing={closingrow}
                        width={15}
                        title={datas["NamaJabatan"]}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={7}
                        title={Math.round(datas["UpahPokok"]).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={7}
                        title={datas["JamLembur"]}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={7}
                        title={Math.round(datas["TotalMakanLembur"]).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={8}
                        title={Math.round(datas["TotalLembur"]).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={8}
                        title={Math.round(totalAll).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={7}
                        title={parseFloat(datas["BPJSTK"]).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={7}
                        title={parseFloat(datas["BPJSKS"]).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        <HeaderTableMaker
                        number={true}
                        closing={closingrow}
                        width={8}
                        title={(Math.round(totalAllBulat/1000) *1000).toLocaleString("in-ID", {maximumFractionDigits: 2,})}
                        />
                        
                    </View>
                </View>
            )
        }
        )}
        
        {/* <View style={styles.table}>
            <View style={[styles.tableRow]}>
                <HeaderTableMaker
                width={20}
                title={props.data}
                />
                <HeaderTableMakerMid
                width={15}
                title={""}
                />
                <HeaderTableMakerMid
                width={9}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={10}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={8}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={10}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={8}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={8}
                title={""}
                />
                <HeaderTableMakerMid
                number={true}
                width={12}
                title={""}
                />
                
            </View>
        </View> */}
        </>
    )
  }
//   console.log(data.data.Data)
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap orientation="landscape">
        <Image style={styles.logo} src={LOGO_RKS}/>
        <View style={styles.viewHeader}>
          <Text style={styles.title_border}>{"REKAP GAJI KARYAWAN "+`${props.tipeKaryawan !== undefined ? props.tipeKaryawan : ""} ${props.region}`}</Text>
          <Text style={styles.title_border}>{"PERIODE "+data.data.Date}</Text>
          {/* <Text style={styles.header_title}>{" "}</Text> */}
          {/* <Text style={styles.title_border}>PERIODE 21 Juli - 20 Agustus 2024</Text> */}
        </View>

        <View style={styles.paddings} fixed={IsFixed}></View>
        <View style={styles.table} fixed={IsFixed}>
          <View style={[styles.tableRow]}>
            <HeaderTableMakerMid colored={true} width={3} title={""} />
            <HeaderTableMakerMid colored={true} width={8} title={""} />
            <HeaderTableMakerMid
              colored={true}
              width={15}
              title={""}
            />

            <HeaderTableMakerMid
              colored={true}
              width={15}
              title={""}
            />
            <HeaderTableMakerMid colored={true} width={7} title={""} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={7} title={""} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={7} title={"Ext Mkn Lembur"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Lembur"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Jumlah Upah Pokok"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={14} title={"Potongan"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Pembulatan"} padding={"5"} />
          </View>
        </View>
        <View style={styles.table} fixed>
          <View style={[styles.tableRow]}>
            <HeaderTableMakerMid colored={true} width={3} title={"No"} padding={"10"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Nik"} padding={"5"} />
            <HeaderTableMakerMid
              colored={true}
              width={15}
              title={"Nama Karyawan"}
              padding={"5"}
            />

            <HeaderTableMakerMid
              colored={true}
              width={15}
              title={"Jabatan"}
              padding={"5"}
            />
            <HeaderTableMakerMid colored={true} width={7} title={"Upah Pokok"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={7} title={"Jam Lembur"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={7} title={"Rp. 20.000"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Jumlah"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Tunjangan, Extra Mkan & Lembur"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={7} title={"BPJS TK"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={7} title={"BPJS KS"} padding={"5"} />
            <HeaderTableMakerMid colored={true} width={8} title={"Gaji Bersih"} padding={"5"} />

          </View>
        </View>
        {data.data.Data && Object.keys(data.data.Data).map((element, i) => {
            let closing = false;
            const length = Object.keys(data.data.Data).length
            if (i == length - 1) {
              closing = true;
              // setIsFixed(false)
            }
            return (
                <>
                 <RowsBagian data={element} dataobj={data.data} closing={closing}/>
                 {closing && <Grandtotal/>}
                 
                </>
            )
        })}
        <View style={styles.header_section} wrap={false}>
            <View style={styles.header_RightA}>
                <Text style={styles.bottom_ttdNP}>{"Jirre Victori Manopo"}</Text>
                <Text style={styles.bottom_ttd}>{"HR"}</Text>
            </View>
            <View style={styles.header_RightA}>
                <Text style={styles.bottom_ttdNP}>{"Dessi Riyanti"}</Text>
                <Text style={styles.bottom_ttd}>{"FA"}</Text>
            </View>
            <View style={styles.header_RightA}>
                <Text style={styles.bottom_ttdNP}>{"Aris Sugiyanto"}</Text>
                <Text style={styles.bottom_ttd}>{"GM"}</Text>
            </View>
            <View style={styles.header_RightA}>
                <Text style={styles.bottom_ttdNP}>{"Aldi Harris"}</Text>
                <Text style={styles.bottom_ttd}>{"Dirops"}</Text>
            </View>
        </View>
      </Page>
    </Document>
  );
};

const PdfPayrollReport = (props) => {
  const data  = props.data

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-screen -mt-32">
        {data && (
          <PDFViewer className={"h-screen w-screen"}>
            {<PdfPayrollReportFormat data={data} region={props.region} tipeKaryawan={props.tipeKaryawan} />}
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default PdfPayrollReport;
